export default "__VITE_ASSET__0f72c71f__"